import { mapActions, mapGetters, mapMutations } from "vuex";
import { maxLength, minLength, required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import { VueSlideToggle } from "vue-slide-toggle";

export default {
    mixin: [validationMixin],
    props: ["isEdit", "client", "clientType"],
    name: "edit-form-client",
    data() {
        return {
            secondAddresses: [],
            payload: {
                active: 0,
                city: "",
                street: "",
                house: "",
                flat: "",
                name: "",
                surname: "",
                lastname: "",
                phone: "",
            },
            validationErrors: {},
        };
    },
    components: {
        VueSlideToggle,
    },
    validations() {
        return {
            payload: {
                city: {
                    required,
                    minLength: minLength(1),
                    maxLength: maxLength(30),
                },
                street: {
                    required,
                    minLength: minLength(1),
                    maxLength: maxLength(50),
                },
                house: {
                    required,
                    minLength: minLength(1),
                    maxLength: maxLength(8),
                },
                flat: {
                    required,
                    minLength: minLength(1),
                    maxLength: maxLength(8),
                },
                name: {
                    required,
                    minLength: minLength(3),
                    maxLength: maxLength(20),
                },
                surname: {
                    required,
                    minLength: minLength(3),
                    maxLength: maxLength(20),
                },
                phone: {
                    required,
                    minLength: minLength(19),
                },
                active: {},
            },
        };
    },
    created() {
        if (this.user.agent_status === 2) {
            this.fetchAgentClients().then(() => {});
        }
        this.payload.city = this.client.city;
        this.payload.flat = this.client.flat;
        this.payload.house = this.client.house;
        this.payload.street = this.client.street;
        this.payload.id = this.client.id;
        this.payload.name = this.client.name;
        this.payload.surname = this.client.first_name;
        this.payload.lastname = this.client.second_name;
        this.payload.phone = this.client.phone;
    },
    computed: {
        ...mapGetters({
            user: "profile/user",
            agentClients: "profile/agentClients",
        }),
        nameErrors() {
            let error = [];
            if (!this.$v.payload.name.$dirty) {
                return error;
            }
            if (!this.$v.payload.name.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.name.maxLength) {
                error.push(this.$t("validationMax") + " 20");
            }
            if (!this.$v.payload.name.minLength) {
                error.push(this.$t("validationMin") + " 3");
            }
            if (this.validationErrors.name) {
                this.validationErrors.name.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        surnameErrors() {
            let error = [];
            if (!this.$v.payload.surname.$dirty) {
                return error;
            }
            if (!this.$v.payload.surname.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.surname.maxLength) {
                error.push(this.$t("validationMax") + " 20");
            }
            if (!this.$v.payload.surname.minLength) {
                error.push(this.$t("validationMin") + " 3");
            }
            if (this.validationErrors.surname) {
                this.validationErrors.surname.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        lastnameErrors() {
            let error = [];
            if (!this.$v.payload.lastname.$dirty) {
                return error;
            }
            if (!this.$v.payload.lastname.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.lastname.maxLength) {
                error.push(this.$t("validationMax") + " 20");
            }
            if (!this.$v.payload.lastname.minLength) {
                error.push(this.$t("validationMin") + " 3");
            }
            if (this.validationErrors.lastname) {
                this.validationErrors.lastname.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        phoneErrors() {
            let error = [];
            if (!this.$v.payload.phone.$dirty) {
                return error;
            }
            if (!this.$v.payload.phone.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.phone.minLength) {
                error.push(this.$t("validationLengthPhone"));
            }
            if (this.validationErrors.phone) {
                this.validationErrors.phone.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        cityErrors() {
            let error = [];
            if (!this.$v.payload.city.$dirty) {
                return error;
            }
            if (!this.$v.payload.city.minLength) {
                error.push(this.$t("validationMin") + " 1");
            }
            if (!this.$v.payload.city.maxLength) {
                error.push(this.$t("validationMax") + " 30");
            }
            if (!this.$v.payload.city.required) {
                error.push(this.$t("validationRequired"));
            }
            if (this.validationErrors.city) {
                this.validationErrors.city.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        streetErrors() {
            let error = [];
            if (!this.$v.payload.street.$dirty) {
                return error;
            }
            if (!this.$v.payload.street.minLength) {
                error.push(this.$t("validationMin") + " 1");
            }
            if (!this.$v.payload.street.maxLength) {
                error.push(this.$t("validationMax") + " 50");
            }
            if (!this.$v.payload.street.required) {
                error.push(this.$t("validationRequired"));
            }
            if (this.validationErrors.street) {
                this.validationErrors.street.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        houseErrors() {
            let error = [];
            if (!this.$v.payload.house.$dirty) {
                return error;
            }
            if (!this.$v.payload.house.minLength) {
                error.push(this.$t("validationMin") + " 1");
            }
            if (!this.$v.payload.house.maxLength) {
                error.push(this.$t("validationMax") + " 8");
            }
            if (!this.$v.payload.house.required) {
                error.push(this.$t("validationRequired"));
            }
            if (this.validationErrors.house) {
                this.validationErrors.house.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        flatErrors() {
            let error = [];
            if (!this.$v.payload.flat.$dirty) {
                return error;
            }
            if (!this.$v.payload.flat.minLength) {
                error.push(this.$t("validationMin") + " 1");
            }
            if (!this.$v.payload.flat.maxLength) {
                error.push(this.$t("validationMax") + " 8");
            }
            if (!this.$v.payload.flat.required) {
                error.push(this.$t("validationRequired"));
            }
            if (this.validationErrors.flat) {
                this.validationErrors.flat.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
    },
    methods: {
        ...mapActions({
            fetchUserData: `profile/FETCH_USER_DATA`,
            fetchAgentClients: `profile/GET_AGENT_CLIENTS`,
            deleteUserAddress: `profile/REMOVE_USER_ADDRESS`,
            deleteAgentClient: `profile/REMOVE_AGENT_CLIENT`,
            editAgentClient: `profile/EDIT_AGENT_CLIENT`,
        }),
        ...mapMutations({
            changePopupMainAddress: `profile/CHANGE_POPUP_MAIN_ADDRESS`,
            setAgentClients: `profile/SET_AGENT_CLIENTS`,
        }),
        removeClient() {
            let obj = {};
            obj.id = this.client.id;
            this.deleteAgentClient(obj)
                .then(() => {
                    this.$toasted.success(this.$t("youClientRemove"));
                    this.$emit("close", "false");
                    this.fetchAgentClients();
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        console.log(error.response);
                    }
                });
        },
        cancelEdit() {
            this.payload.city = this.client.city;
            this.payload.street = this.client.street;
            this.payload.house = this.client.house;
            this.payload.flat = this.client.flat;
            this.payload.name = this.client.name;
            this.payload.surname = this.client.first_name;
            this.payload.lastname = this.client.second_name;
            this.payload.phone = this.client.phone;
            this.$nextTick(() => {
                this.$v.$reset();
            });
            this.$emit("close", "false");
        },
        submit() {
            this.$v.$touch();
            let obj = {};
            obj.city = this.payload.city;
            obj.street = this.payload.street;
            obj.house = this.payload.house;
            obj.flat = this.payload.flat;
            obj.id = this.payload.id;
            obj.name = this.payload.name;
            obj.first_name = this.payload.surname;
            obj.second_name = this.payload.lastname;
            obj.phone = this.payload.phone.replace(/[\s.,%()-]/g, "");
            obj.type = this.clientType;

            // console.log(obj)
            if (!this.$v.$invalid) {
                this.editAgentClient(obj)
                    .then(() => {
                        this.$toasted.success(this.$t("clientUpdate"));
                        this.fetchAgentClients();
                        this.$emit("close", "false");
                    })
                    .catch(error => {
                        if (error.response.status === 422) {
                            console.log(error.response);
                        }
                    });
            }
        },
    },
};
